module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray-849ffb2cdbd81ee92ed09f9d952cecec.png";